import React, { useState } from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import logo from "../../assets/images/phyohandmade/phyologo.png";

function Header() {
    const [showMenu, setShowMenu] = useState(false)
    return (
        <div>
            <div class="navbar w-full fixed bg-base-100 text-base-content">
                <div class="navbar-start">
                    <Link to={paths.home} className=""><img src={logo} /></Link>
                </div>
                

                <div className="block lg:hidden pr-4">
                    <button onClick={() => setShowMenu(!showMenu)} id="nav-toggle" className="flex items-center p-1  focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out">
                        <svg className="fill-current h-6 w-6" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <title>Menu</title>
                            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                        </svg>
                    </button>
                </div>
                <div className={`w-full lg:flex lg:items-center lg:w-auto ${showMenu ? 'flex' : 'hidden'}  mt-2 lg:mt-0  p-4 lg:p-0 z-20`} id="nav-content">
                    <ul className="list-reset lg:flex justify-end flex-1 items-center">
                        <li className="p-2 tracking-wider text-lg "><Link to={paths.home}>Home</Link></li>
                        <li className="p-2 tracking-wider text-lg "><Link to={paths.about}>About Us</Link></li>
                        <li className="p-2 tracking-wider text-lg "><Link to={paths.ourart}>Our Artisan</Link></li>
                        <li className="p-2 tracking-wider text-lg "><Link to={paths.contact}>Contact</Link></li>
                        
                    </ul>
                </div>

            </div>

            <nav className="w-full fixed bg-base-100 text-base-content">
            <div class="w-full container mx-auto flex flex-wrap items-center justify-between mt-0 py-2">
                <div className="flex items-center">
                    <Link to={paths.home} className="btn btn-ghost normal-case"><img src={logo} alt="logo"/></Link>
                </div>
                
                <div className="block lg:hidden pr-4">
                    <button onClick={() => setShowMenu(!showMenu)} id="nav-toggle" className="flex items-center p-1  focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out">
                        <svg className="fill-current h-6 w-6" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <title>Menu</title>
                            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                        </svg>
                    </button>
                </div>
                <div className={`w-full flex-grow lg:flex lg:items-center lg:w-auto ${showMenu ? 'flex' : 'hidden'}  mt-2 lg:mt-0  p-4 lg:p-0 z-20`} id="nav-content">
                    <ul className="list-reset lg:flex justify-end flex-1 items-center">
                        <li className="p-2 tracking-wider text-lg "><Link to={paths.home}>Home</Link></li>
                        <li className="p-2 tracking-wider text-lg "><Link to={paths.about}>About Us</Link></li>
                        <li className="p-2 tracking-wider text-lg "><Link to={paths.ourart}>Our Artisan</Link></li>
                        <li className="p-2 tracking-wider text-lg "><Link to={paths.contact}>Contact</Link></li>
                    </ul>
                </div>
            </div>
        </nav>
        </div>

        


    );
}

export default Header;